import React, { useState } from 'react';
import DocumentRequestModal from "./DocumentRequestModal";

// Import components
import Header from './Header';

const Search = () => {
    const [loading, setLoading] = useState(true);
    const [loadingmylex, setLoadingMyLex] = useState(true);

    /**
     * Event handler for the mylexsearchready event.
     */
    const mylexSearchReady = () => {
        console.log("MY-LEX search is ready!");

        setLoadingMyLex(false);

        // Remove the event lister when we are done.
        document.removeEventListener('mylexsearchready', mylexSearchReady);
    }

    // Register the document event listener in the React.useEffect so the event are added after the page is loaded.
    React.useEffect(() => {
        // this simulates an async action, after which the component will render the content
        document.addEventListener('mylexsearchready', mylexSearchReady, false);

        setLoading(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {

        // When the react app is still loading, we return null. this will trigger the loader "sk-cube-grid-1" in index.html to be shown.
        return null;
    } else {

        const Loader = () => {
            if (loadingmylex) {
                return (
                    <>
                        <div className="modal-backdrop fade"></div>
                        <div className="modal fade show d-block">
                            <div className="modal-dialog">
                                <div className="loader loading">
                                    <div className="sk-cube-grid-2">
                                        <div className="sk-cube sk-cube1"></div>
                                        <div className="sk-cube sk-cube2"></div>
                                        <div className="sk-cube sk-cube3"></div>
                                        <div className="sk-cube sk-cube4"></div>
                                        <div className="sk-cube sk-cube5"></div>
                                        <div className="sk-cube sk-cube6"></div>
                                        <div className="sk-cube sk-cube7"></div>
                                        <div className="sk-cube sk-cube8"></div>
                                        <div className="sk-cube sk-cube9"></div>
                                    </div>
                                </div>
                            </div>
                               
                        </div>
                    </>
                );
            }
            return (<div></div>);
        }

        return (
            <>
                <Loader />

                <div className="page-container bg-lines-light">
                    <div className="page-content">
                        <mylex-component type="skiplinks" params="{'ComponentName':'TopSkipLinks'}"></mylex-component>
                        <Header></Header>

                        <div className="container-fluid flex-grow d-flex flex-column">
                            <div className="row search-box">
                                <div className="col-md-6 col-sm-12 col-12 offset-md-3 position-relative">
                                    <mylex-component type="searchbar" params="{'searchPlaceholder':'Zoek bijvoorbeeld op plaats, straat en huisnummer'}"></mylex-component>
                                    {/* WCAG focus/status shell: IDs consumed by mylexwebcomponents jsInterop (requires matching components build) */}
                                    <div id="searchResultsUpdated" tabIndex={-1} className="visually-hidden"></div>
                                    <div id="searchStatusAnnouncer" role="status" aria-live="polite" aria-atomic="true" className="visually-hidden"></div>
                                    <mylex-component type="skiplinks" params="{'ComponentName':'AfterSearchSkipLinks'}"></mylex-component>
                                </div>
                            </div>
                            <section className="row" aria-label="Resultaten lijst opties">
                                <div className="col-12 col-xxl-10 offset-xxl-1">
                                    <div className="row">
                                        <div className="col-12">
                                            <mylex-component type="searchfeedback"></mylex-component>
                                        </div>
                                    </div>

                                    <div className="row g-0 mb-3 align-items-start">
                                        <div className="col-6 col-xxl-2 mb-1 order-2 order-xxl-1">
                                            <mylex-component type="aggregationactions"></mylex-component>
                                        </div>

                                        <div className="col-12 col-xxl-8 mb-2 pl-xxl-2 mb-xxl-0 order-1 order-xxl-2">
                                            <mylex-component type="aggregationtags"></mylex-component>
                                        </div>

                                        <div className="col-6 col-xxl-2 order-3">
                                            <div className="d-flex justify-content-end text-nowrap">
                                                <div className="btn-group btn-group-sm" role="group" aria-label="Resultaat weergave opties">
                                                    <mylex-component type="sorting" class="d-flex justify-content-end text-nowrap"></mylex-component>
                                                    <mylex-component type="pagesizedropdown"></mylex-component>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>
                            <div className="row">
                                <div className="col-12 col-xxl-10 offset-xxl-1">
                                    <div className="row" id="row-main">

                                        <aside id="aggregations" className="aggregations-column col-12 col-md-3 col-xxl-2 bg-gray-100" aria-labelledby="offcanvasRefineTitle">
                                            <div id="offcanvas-aggregations" className="offcanvas-md offcanvas-start" tabIndex={-1} aria-labelledby="offcanvasRefineTitle">
                                                <div className="aggregations-header d-block d-md-none d-flex justify-content-between align-items-center border-bottom offcanvas-header">
                                                    <h1 id="offcanvasRefineTitle" className="text-mylex-gray text-size-medium lead header-uppercase offcanvas-title">Verfijnopties</h1>
                                                    <button type="button" className="btn-close text-size-large" data-bs-dismiss="offcanvas" data-bs-target="#offcanvas-aggregations">
                                                        <span className="visually-hidden">Verfijn opties sluiten</span>
                                                    </button>
                                                </div>
                                                <div className="aggregations-body d-block offcanvas-body">
                                                    <mylex-component type="aggregations"></mylex-component>
                                                </div>
                                            </div>
                                        </aside>
                                        <section id="results" className="col" aria-label="Zoekresultaten">
                                            <mylex-component type="resultlist"></mylex-component>
                                            <mylex-component type="pagination"></mylex-component>
                                        </section>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <mylex-component type="document" params="{'SupportEnlargedThumbnail': false }"></mylex-component>
                        <DocumentRequestModal />
                    </div>


                    <footer className="page-footer container-fluid body-bg-color">
                        <div className="row p-5">
                            <div className="col-md-10 col-12 offset-md-1 font-ptsans text-center text-size-large">
                                <div><span>Vragen over het e-depot? Meer informatie is te vinden op onze pagina</span> <a href="https://bhic.nl/onderzoeken/hulp-bij-onderzoek/e-depot" target="_blank" rel="noopener noreferrer">hulp bij onderzoek e-depot</a>.</div>
                                <div><span>Wil je bezwaar maken tegen een publicatie? Bekijk onze</span> <a href="https://www.bhic.nl/over-ons/cookies-en-privacy" target="_blank" rel="noopener noreferrer">disclaimer</a> <span>voor meer informatie.</span></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10 col-12 offset-md-1 text-end">
                                <p className="small text-mylex-gray">
                                    <mylex-component type="version"></mylex-component>
                                </p>
                            </div>
                        </div>
                    </footer>

                </div>
                <mylex-component type="navigationmanager"></mylex-component>
                <mylex-component type="pagetitle" params="{'ApplicationName':'Brabants Historisch Informatie Centrum'}"></mylex-component>
                <mylex-component type="radzencomponents"></mylex-component>
            </>
        );
    }
}

export default Search;